import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function useCountdown(targetDate: Date) {
  const calc = () => {
    const diff = targetDate.getTime() - Date.now();
    if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  };
  const [time, setTime] = useState(calc);
  useEffect(() => {
    const t = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(t);
  }, []);
  return time;
}

export default function PromoCountdown() {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);
  // Countdown to end of free trial promo (3 months from now)
  const target = new Date("2026-07-11T23:59:59");
  const { days, hours, minutes, seconds } = useCountdown(target);

  if (dismissed) return null;

  return (
    <div className="bg-gradient-to-r from-red-600 via-red-500 to-orange-500 text-white relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-32 h-32 bg-white rounded-full -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-1/3 w-24 h-24 bg-white rounded-full translate-y-1/2"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
        {/* Left: promo text */}
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0">
            <i className="ri-vip-crown-line text-white text-xl"></i>
          </div>
          <div>
            <div className="flex items-center gap-2 flex-wrap">
              <span className="bg-white text-red-500 text-xs px-2.5 py-0.5 rounded-full font-bold whitespace-nowrap">
                限时优惠
              </span>
              <p className="text-white font-bold text-base whitespace-nowrap">
                工厂会员 <span className="text-yellow-300">前3个月完全免费</span>，之后仅 ¥5/月
              </p>
            </div>
            <p className="text-white/75 text-xs mt-0.5">
              分销商会员永久免费 · 立即加入，享受专属佣金收益
            </p>
          </div>
        </div>

        {/* Center: countdown */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <span className="text-white/70 text-xs whitespace-nowrap">优惠倒计时</span>
          {[
            { val: days, label: "天" },
            { val: hours, label: "时" },
            { val: minutes, label: "分" },
            { val: seconds, label: "秒" },
          ].map((unit, i) => (
            <div key={unit.label} className="flex items-center gap-1">
              {i > 0 && <span className="text-white/60 font-bold text-sm">:</span>}
              <div className="flex flex-col items-center">
                <div className="bg-black/30 rounded-md w-9 h-8 flex items-center justify-center">
                  <span className="text-white font-bold text-sm tabular-nums">
                    {String(unit.val).padStart(2, "0")}
                  </span>
                </div>
                <span className="text-white/60 text-xs mt-0.5">{unit.label}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Right: CTA */}
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={() => navigate("/reseller-dashboard")}
            className="bg-white text-red-500 hover:bg-red-50 px-5 py-2 rounded-xl font-bold text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-user-add-line mr-1"></i>立即加入
          </button>
          <button
            onClick={() => setDismissed(true)}
            className="w-7 h-7 flex items-center justify-center text-white/60 hover:text-white cursor-pointer transition-colors"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
